import React from "react"
import { HashLink as Link } from "react-router-hash-link"
import ArticleLayout from "components/ArticleLayout"
import PageHeader from "blocks/PageHeader"
import BodyText from "blocks/BodyText"
import FootnoteBody from "blocks/FootnoteBody"
import { countFootnotes } from "blocks/FootnoteBody"
import ScrollToTop from "blocks/ScrollToTop"

import "./Faq.scss"

const ChapteredPage = ({ page }) => {
  return <React.Fragment>
    <PageHeader className="center pad">
      <h1>{page.title}</h1>
    </PageHeader>
    <ScrollToTop />
    <ArticleLayout side="left">
      <div className="faq-nav">
        <Nav items={page.qabuilder} />
      </div>
      <div>
        <QuestionBlocks blocks={page.qabuilder} />
      </div>
    </ArticleLayout>
  </React.Fragment>
}

const QuestionBlocks = ({ blocks }) => {
  let nextFootnoteNumber = 1

  const renderAnswer = (section) => {
    if (!section?.id) {
      return null
    }

    const footnoteBody = section.textWithFootnote?.html || section.textWithFootnote?.rawHtml
    const startNumber = nextFootnoteNumber

    if (footnoteBody) {
      nextFootnoteNumber += countFootnotes(footnoteBody)
    }

    return <div key={section.id}>
      {section.copy ? <h4>{section.copy}</h4> : null}
      {section.body ? <BodyText body={section.body} /> : null}
      {footnoteBody ? <FootnoteBody body={footnoteBody} startNumber={startNumber} /> : null}
    </div>
  }

  return <div>
    {blocks.map(block =>
      <div id={`question-${block.id}`} key={block.id} className="question">
        <h2>{block.heading}</h2>
        {block.children ? block.children.map(child => {
          if (child.typeHandle === "questionAnswer") {
            return <div className="question-section" key={child.id} id={`question-${child.id}`} >
              <div className="question-block article">
                {renderAnswer(child)}
              </div>
            </div>
          }

          return <div className="question-section" key={child.id} id={`question-${child.id}`} >
            <h3>{child.heading}</h3>
            <div className="question-block article">
              {child.children ? child.children.map(renderAnswer) : null}
            </div>
          </div>
        }) : null}
      </div>
    )}
  </div>
}

const Nav = ({ items }) => {
  return <ul className="faq-nav-list sticky">
    {items.map(list => <li key={list.id}>
      <Link smooth to={`#question-${list.id}`} className="section-header left" title={`scroll to ${list.heading}`}>{list.heading}</Link>
      {list.children ?
        <ul>{list.children.map(child => {
          if (child.typeHandle === "questionSection") {
            return <li key={child.id} className="section-subheader">
              <Link smooth to={`#question-${child.id}`} title={`scroll to ${child.heading}`}>{child.heading}</Link>
            </li>
          } else return null
        })}
        </ul>
        : null}
    </li>)}
  </ul>
}

export default ChapteredPage
